import React, { useState } from 'react';
import './FlowStageVerifyPhotos.scss';
import BodyScanHeader from './BodyScanHeader'
import {EpicSpinner} from '../../../components/index';

import Div100Vh from 'react-div-100vh'

const FlowStageVerifyPhotos = ({ photos, onRestart, onCancel, onPhotosVerified }) => {
  const [uploading, setUploading] = useState(false)

  const verify = () => {
    setUploading(true)
    onPhotosVerified()
  }

  return (
    <Div100Vh className="flow-stage-verify-photos--container">
      <BodyScanHeader {...{onRestart, onCancel}}/>

      <p>Check your photos:</p>
      <div className="photo-container">
        {photos.map((p, i) => <div key={`${i}`} className="img" style={{ backgroundImage: `url(${p})`}}>&nbsp;</div>)}
      </div>

      <button onClick={verify}>Yes</button>
      <button onClick={onRestart}>No, Restart</button>
      {!!uploading && 
        <EpicSpinner />
      }
    </Div100Vh>
  );
};

export default FlowStageVerifyPhotos;
